import React from 'react';
import { FilterSelectNative } from '@/components/custom/filter';

const EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)';

const ETAPAS = [
  { value: 'serie_3_em', label: '3ª EM' },
  { value: 'ano_9_ef', label: '9º EF' },
  { value: 'ano_5_ef', label: '5º EF' },
  { value: 'ano_2_ef', label: '2º EF' }
];

function FilterGroup({ label, children }) {
  return (
    <div>
      <span className="mb-2 block text-xs font-semibold uppercase tracking-wide text-neutral-light">{label}</span>
      <div className="flex flex-wrap gap-1.5">{children}</div>
    </div>
  );
}

function Chip({ active, onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-active={active}
      className={[
        'inline-flex select-none items-center rounded-full border px-3 py-1 text-xs',
        'transition-[transform,colors,border-color,background-color] duration-200',
        'active:scale-[0.96]',
        active ? 'border-primary bg-primary text-white shadow-[0_1px_2px_rgba(0,0,0,0.06)]' : 'hover:border-primary/40 hover:bg-primary/[0.03] border-neutral-lightest bg-white text-neutral-dark'
      ].join(' ')}
      style={{ transitionTimingFunction: EASE_OUT }}
    >
      {children}
    </button>
  );
}

/**
 * Filtros padrão GATE (Etapa server-side + Modalidade/busca).
 * Usado apenas no fluxo de simulados. `resetResults` zera a lista paginada
 * quando um filtro server-side muda, forçando refetch a partir da página 1.
 */
export default function GateFilters({ filters, modalitys, resetResults, t }) {
  return (
    <div className="filter-bar mb-4">
      <div className="filter-bar__inner grid gap-4">
        <div className="grid gap-3">
          <FilterGroup label="Etapa">
            {ETAPAS.map(e => (
              <Chip
                key={e.value}
                active={(filters.values.etapa || []).includes(e.value)}
                onClick={() => {
                  const current = filters.values.etapa || [];
                  const next = current.includes(e.value) ? current.filter(v => v !== e.value) : [...current, e.value];
                  filters.setFieldValue('etapa', next);
                  resetResults();
                }}
              >
                {e.label}
              </Chip>
            ))}
          </FilterGroup>
        </div>

        <div className="flex flex-wrap items-end gap-3">
          <FilterSelectNative
            label={t('filter.selectQuestionType')}
            blankLabel={t('filter.blankLabelAll')}
            value={filters.values.modality}
            onChange={e => {
              filters.setFieldValue('modality', e.target.value);
            }}
            options={modalitys.map(item => item)}
          />

          <input
            style={{ position: 'sticky', top: '0' }}
            className="form__control mb-0 flex-1"
            type="search"
            placeholder={t('exams.placeholderSearchQuestion')}
            onChange={e => filters.setFieldValue('searchTerm', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
